module.exports = __webpack_public_path__ + "static/media/neutral_medium_4950.png.552f6afb.webp";